module.exports = __webpack_public_path__ + "img/feedback3.5a1d2c00.png";